import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import dropdownImage from "../../../../assets/images/forwardRedz.svg";
import BackButton from "../../../../components/common/BackButton";
import { setSelectedPolicy } from "../rewardSlice";
import noRewardsImage from "../../../../assets/images/AccessDen.png";
// import { setSelectedPolicy } from "../rewardSlice";

export const RewardPolicyMenu = ({ data, setPolicy }) => {
  const dispatch = useDispatch();
  const [internalPolicy, setInternalPolicy] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const [policies, setPolicies] = useState(null);
  const [sewaPolicies, setSewaPolicies] = useState(null);
  const [cidrPolicies, setCidrPolicies] = useState(null);
  const [cidrDisplayName, setCidrDisplayName] = useState(null);
  const [sewaDisplayName, setSewaDisplayName] = useState(null);

  useEffect(() => {
    const cidrReward = data?.data?.cidrRewards?.cidr;
    const sewaReward = data?.data?.sewaRewards?.sewa;
    const cidrName = data?.data?.cidrDisplayName;
    const sewaName = data?.data?.sewaDisplayName;

    let sewaPolicies = [];
    let cidrPolicies = [];

    if (sewaReward) {
      Object.keys(sewaReward).forEach((policyNo) => {
        sewaPolicies.push({
          policyNo: policyNo,
          type: "SEWA",
          data: sewaReward[policyNo],
        });
      });
    }

    if (cidrReward) {
      Object.keys(cidrReward).forEach((policyNo) => {
        cidrPolicies.push({
          policyNo: policyNo,
          type: "CIDR",
          data: cidrReward[policyNo],
        });
      });
    }

    setSewaPolicies(sewaPolicies);
    setCidrPolicies(cidrPolicies);
    setCidrDisplayName(cidrName);
    setSewaDisplayName(sewaName);

    const combinedPolicies = [...sewaPolicies, ...cidrPolicies];
    setPolicies(combinedPolicies);

    if (combinedPolicies.length > 0) {
      setInternalPolicy(combinedPolicies[0]);
      setPolicy(combinedPolicies[0]);
      dispatch(setSelectedPolicy(combinedPolicies[0].policyNo));
    }
  }, [data]);

  return (
    <>
      {data && internalPolicy ? (
        <>
          <div className="pb-0 flex justify-between relative text-lightblack ">
            <div className="flex flex-col w-full gap-y-2">
              <div className="flex font-bold text-base  items-center leading-5">
                {/* <BackButton /> */}
                <span className="px-2">My rewards</span>
              </div>
              <div className="outline outline-1 outline-[#D9D9D9] rounded-md flex justify-between mt-2 relative p-2 items-center">
                <div
                  className="flex justify-between w-full items-center "
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <span className="px-3 font-semibold ">
                    Policy number: {internalPolicy.policyNo}
                  </span>
                  <div>
                    <img
                      src={dropdownImage}
                      alt=""
                      className={`w-6 h-6 ${
                        isOpen ? "-rotate-90" : "rotate-90"
                      } mr-5`}
                    />
                  </div>
                </div>

                {isOpen && (
                  <>
                    <div
                      className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-90 pointer-events-auto"
                      onClick={() => setIsOpen(false)}
                    ></div>
                    <div
                      className="fixed bg-white z-100 bottom-0 left-0 w-full rounded-tl-lg rounded-tr-lg border-2 border-slate-300 overflow-auto flex flex-col justify-start"
                      style={{ border: "1px solid #d9d9d9", maxHeight: "50vh" }}
                    >
                      {sewaPolicies.length > 0 && (
                        <>
                          <div className="bg-gray-200 p-3 font-semibold text-sm">
                            {sewaDisplayName}
                          </div>
                          {sewaPolicies.map((policy) => (
                            <button
                              key={policy.policyNo}
                              className="text-lightblack text-xs bg-white w-full h-full p-4 text-left"
                              onClick={() => {
                                setIsOpen(!isOpen);
                                setPolicy(policy);
                                dispatch(setSelectedPolicy(policy.policyNo));
                                setInternalPolicy(policy);
                              }}
                              style={{ borderBottom: "1px solid #d9d9d9" }}
                            >
                              <span className=" text-sm leading-5">
                                Policy number: {policy.policyNo}
                              </span>
                            </button>
                          ))}
                        </>
                      )}
                      {cidrPolicies.length > 0 && (
                        <>
                          <div className="bg-gray-200 p-3 font-semibold text-sm">
                            {cidrDisplayName}
                          </div>
                          {cidrPolicies.map((policy) => (
                            <button
                              key={policy.policyNo}
                              className="text-lightblack text-xs bg-white w-full h-full p-4 text-left"
                              onClick={() => {
                                setIsOpen(!isOpen);
                                setPolicy(policy);
                                dispatch(setSelectedPolicy(policy.policyNo));
                                setInternalPolicy(policy);
                              }}
                              style={{ borderBottom: "1px solid #d9d9d9" }}
                            >
                              <span className="text-sm leading-5">
                                Policy number: {policy.policyNo}
                              </span>
                            </button>
                          ))}
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="flex flex-col items-center justify-center h-screen">
          <img src={noRewardsImage} alt="No Rewards" className="w-1/2 mb-4" />
          <p className="font-bold text-center">Not eligible to earn rewards</p>
          <p className="text-sm text-gray-500 text-center">
            Subscribed policies are not eligible for rewards
          </p>
        </div>
      )}
    </>
  );
};
